export const appUrl = () => {
  return useRuntimeConfig().public.appUrl;
};

export const appUrlUpper = () => {
  return appUrl().toLocaleUpperCase();
};

export const isBetBr = () => {
  return appUrl().includes('bet.br');
};

export const appName = () => {
  return useRuntimeConfig().public.appName;
};

export const appNameUpper = () => {
  return appName().toLocaleUpperCase();
};

export const appNameLower = () => {
  return appName().toLocaleLowerCase();
};

export const currentLocale = () => {
  return 'pt-br';
};

export const isDev = () => {
  return !!(
    useRuntimeConfig().public.nodeEnv !== 'production' ||
    useRuntimeConfig().public.nodeDebug === true
  );
};

export const isStage = () => {
  return !!useRuntimeConfig().public.originDomain.includes('stage');
};

export const isHomolog = () => {
  return useRuntimeConfig().public.appUrl.includes('homolog');
};

export const isProduction = () => {
  return useRuntimeConfig().public.nodeEnv === 'production' && !isHomolog();
};

export const originDomain = () => {
  return useRuntimeConfig().public.originDomain;
};

export const localeLink = (path: string | object): string => {
  if (typeof path === 'string') {
    return path;
  }
  if ('path' in path && typeof path.path === 'string') {
    return path.path;
  }

  return '/';
};

export function getAssetsUrlForCDN(image: string) {
  if (image.charAt(0) !== '/') {
    return image;
  }

  // Tratamento específico para Cloudflare Image Delivery
  if (image.includes('imagedelivery.net')) {
    // Detecta se é mobile (até 600px) e ajusta o path
    if (import.meta.client) {
      const clientWidth = window.screen.width || window.innerWidth;

      if (clientWidth <= 600) {
        // Remove /public e adiciona /mobile para dispositivos móveis
        image = image.replace('/public', '/mobile');
      }
    }
  }

  let static_cdn;

  try {
    static_cdn = useRuntimeConfig().public.appStaticCdn;
  } catch (e) {
    try {
      static_cdn = process.env.APP_STATIC_CDN;
    } catch (e) {
      console.error('Error getting CDN URL', e);
    }
  }

  if (static_cdn) {
    return `${static_cdn}${image}`;
  }

  return image;
}

export function getUrlForApiImage(image: string) {
  if (!image) return undefined;

  // Tratamento específico para Cloudflare Image Delivery
  if (image.includes('imagedelivery.net')) {
    // Remove /public se existir
    image = image.replace('/public', '');

    // Parâmetros base para otimização
    const params = new URLSearchParams();

    // Ajuste de largura baseado no tamanho da tela (apenas no cliente)
    if (import.meta.client) {
      const clientWidth = window.screen.width || window.innerWidth;

      let imageWidth;

      if (clientWidth >= 1200) {
        imageWidth = 1200; // lg
      } else if (clientWidth >= 768) {
        imageWidth = 900; // md
      } else {
        imageWidth = 600; // sm
      }

      // Adiciona o parâmetro de largura no formato /w=1200
      image = `${image}/w=${imageWidth}`;
    }

    // Otimizações adicionais
    params.append('quality', '95'); // Qualidade otimizada
    params.append('format', 'auto'); // Formato automático

    // Adiciona os parâmetros à URL
    const separator = image.includes('?') ? '&' : '?';

    return `${image}${separator}${params.toString()}`;
  } else {
    // Se for uma URL externa que não é do Cloudflare, retorna como está
    if (image.startsWith('https://') || image.startsWith('http://')) {
      return image;
    }

    // Se for uma imagem local, retorna o caminho do storage
    return '/api/storage/' + image;
  }
}
